import { render, staticRenderFns } from "./configs.vue?vue&type=template&id=a38d0148&scoped=true"
import script from "./configs.vue?vue&type=script&lang=js"
export * from "./configs.vue?vue&type=script&lang=js"
import style0 from "./configs.vue?vue&type=style&index=0&id=a38d0148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38d0148",
  null
  
)

export default component.exports